import _ from 'lodash';

function isRegexPathNameMatch(routePath: $TSFixMe, pathName: $TSFixMe) {
  return new RegExp(pathName).test(routePath.replace(/^\/|\/$/g, ''));
}

function isPathNameMatch(routePath: $TSFixMe, pathName: $TSFixMe) {
  return pathName.replace(/^\/|\/$/g, '') === routePath.replace(/^\/|\/$/g, '');
}

function clearEmptyFields(obj: $TSFixMe) {
  const currObj = Object.assign({}, obj);
  const keys = Object.keys(currObj);

  keys.forEach((k) => {
    if (!currObj[k]) {
      delete currObj[k];
    }
  });

  return currObj;
}

/*
  We use the fully qualified url (except the protocol) as a look up key to get the 
  seo override rule. For example:
  /courses?language=en and /courses?language=fe, each url will have its own dedicated override
  rule defined by our SEO team. 
*/
function getOverrideRules(routeLocation: $TSFixMe, rules: $TSFixMe) {
  const { hostname, pathname, search } = routeLocation;
  const fullUrl = [hostname, pathname, search].join('');

  const regexRule = _.filter(rules.regex, ({ pathName }) => isRegexPathNameMatch(fullUrl, pathName));
  const absoluteRule = _.filter(rules.absolute, ({ pathName }) => {
    return isPathNameMatch(fullUrl, pathName);
  });
  // absolute rul rule always take precedence over regex rule
  return regexRule.concat(absoluteRule);
}

const exported = {
  getOverrideRules,
};

export default exported;
export { getOverrideRules, clearEmptyFields };
